import { useContext } from 'react';

import { Event } from '@legacy-types';

import EventContext from './EventContext';

export function useEvent(): Event {
  const context = useContext(EventContext);

  if (context === undefined || context === null || context.id === undefined) {
    throw new Error('useEvent must be used within a EventProvider and an event must be set');
  }

  return context;
}
